import mutations from './codedOtherBillableItems.mutations'
import actions from './codedOtherBillableItems.actions'
import getters from './codedOtherBillableItems.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
